import React from 'react';
import { CompanyContext } from '@/components/company/company.context';
import { useReadCompanyQuery } from '@/store/api/company/company.api';
import type { TypeIssuer } from '@/types/commercial/types.commercial.issuer';
import type { TypeCompany } from '@/types/company/types.company';

export const useCompanyState = () => {
    const query = useReadCompanyQuery();
    const status = (query.error as { status?: number } | undefined)?.status;
    return {
        company: query.data ?? null,
        isLoading: query.isLoading,
        isFetching: query.isFetching,
        missing: query.isError && status === 404,
        failed: query.isError && status !== 404,
        refetch: query.refetch,
    };
};

export const useCompany = (): TypeCompany => {
    const company = React.useContext(CompanyContext);
    if (!company) throw new Error('useCompany va usato dentro CompanyGate');
    return company;
};

export const useIssuer = (): TypeIssuer => useCompany().issuer;
